<script>
    import { beforeNavigate, invalidate } from '$app/navigation';
    import { onMount, setContext } from 'svelte';
    import '../app.postcss';

    import {
        install as installAnalytics,
        save_params_of_interest
    } from '$lib/utils/logs.js';
    import Seo from '$lib/Seo.svelte';
    import { page, updated } from '$app/stores';
    import { discount_data, under_maintenance } from '$lib/stores/globals';
    import { install_paddle } from '$lib/utils/paddle';
    import DiscountBanner2 from '$lib/DiscountBanner2.svelte';
    import FacebookPixel from '$lib/FacebookPixel.svelte';
    import TwitterPixel from '$lib/TwitterPixel.svelte';
    // import DiscountBanner from '$lib/DiscountBanner.svelte';
    import { clientGetSplitTestIdentifier } from 'svelte-split-testing';
    import ModalOverlay from '$lib/ModalOverlay.svelte';
    import { PUBLIC_SPECIAL_DISCOUNT } from '$env/static/public';


    export let data;

    let { supabase, session } = data;
    $: ({ supabase, session } = data);

    beforeNavigate(({ to, willUnload }) => {
        if ($updated && willUnload && to?.url) {
            console.log('hard navigating to', to.url.href);
            location.href = to.url.href;
            return false;
        }
    });

    setContext('splitTestIdentifier', data?.split_test_identifier);

    let discount_code = null;
    let enlarged_image_src = null;

    onMount(() => {
        save_params_of_interest();
        installAnalytics();
        const {
            data: { subscription }
        } = supabase.auth.onAuthStateChange((event, _session) => {
            // console.log('auth state change', event, _session);
            if (_session?.expires_at !== session?.expires_at) {
                // console.log('invalidating supabase:auth');
                invalidate('supabase:auth');
            }
        });

        if ($page.url.searchParams.get('d_id')) {
            discount_code = $page.url.searchParams.get('d_id');
        } else if ($page.url.pathname === '/jordan') {
            discount_code = 'JORDAN';
        } else if ($page.url.pathname === '/gifted') {
            discount_code = 'gifted';
        } else if ($page.url.pathname === '/repod') {
            discount_code = 'repod';
        } else if (PUBLIC_SPECIAL_DISCOUNT) {
            discount_code = PUBLIC_SPECIAL_DISCOUNT;
        } else {
            discount_code = localStorage.getItem('discount_code') || null;
        }

        if (discount_code) {
            localStorage.setItem('discount_code', discount_code);

            fetch('/api/paddle/check_code?code=' + discount_code)
                .then((res) => res.json())
                .then((dis) => {
                    if (dis.active) {
                        $discount_data = dis;
                    }
                });
        }

        if ('requestIdleCallback' in window) {
            requestIdleCallback(() => install_paddle());
        } else {
            // Fallback for browsers that do not support requestIdleCallback
            setTimeout(install_paddle, 2000);
        }

        document.addEventListener('click', (e) => {
            if (
                e.target instanceof HTMLElement &&
                (e.target.matches('.js-thumb-img-link') ||
                    e.target.closest('.js-thumb-img-link'))
            ) {
                console.log('clicked thumb img link');
                e.preventDefault();
                e.stopPropagation();

                let target = e.target;
                if (target.tagName.toLowerCase() === 'img') {
                    // @ts-ignore
                    target = target.parentNode;
                }

                // @ts-ignore
                enlarged_image_src = target.href;
            }
        });

        return () => subscription.unsubscribe();
    });
    
</script>

{#key $page.route}
    <Seo />
{/key}

<svg id="icon-store" viewBox="0 0 24 24" class="hidden">
    <!-- Play icon: Triangle shape pointing right. Starts at x=8, y=5, moves vertically down 14 units, then diagonally to x=19, y=12 (center), and back to x=8, y=5 -->
    <path id="play" d="M8 5v14l11-7z" fill="currentColor" />
    <!-- Pause icon: Two vertical rectangles. First rectangle starts at x=8, y=5, with width 4 and height 14. Second rectangle starts at x=16, y=5, with the same dimensions -->
    <path id="pause" d="M8 5h4v14H8zM16 5h4v14h-4z" fill="currentColor" />

    <!-- <path id="text_left" stroke-linecap="round" stroke="currentColor" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12" /> -->
    <path
        id="captions"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 7C0 4.79086 1.79086 3 4 3H20C22.2091 3 24 4.79086 24 7V17C24 19.2091 22.2091 21 20 21H4C1.79086 21 0 19.2091 0 17V7ZM16.0278 15.6191C15.3176 15.6191 14.7096 15.4785 14.2039 15.1973C13.6982 14.9132 13.3105 14.5183 13.0406 14.0126C12.7707 13.5041 12.6357 12.9146 12.6357 12.2441C12.6357 11.5737 12.7707 10.9856 13.0406 10.4799C13.3105 9.97141 13.6982 9.57653 14.2039 9.29528C14.7096 9.01119 15.3176 8.86914 16.0278 8.86914C16.6698 8.86914 17.2252 8.98562 17.694 9.21857C18.1656 9.44869 18.5306 9.77539 18.7892 10.1987C19.0477 10.6191 19.1784 11.1135 19.1812 11.6816H16.9994C16.9681 11.3379 16.8687 11.0765 16.7011 10.8975C16.5363 10.7157 16.3232 10.6248 16.0619 10.6248C15.8573 10.6248 15.6784 10.6845 15.5249 10.8038C15.3715 10.9203 15.2522 11.0978 15.167 11.3365C15.0818 11.5723 15.0392 11.8691 15.0392 12.2271C15.0392 12.5851 15.0818 12.8833 15.167 13.122C15.2522 13.3578 15.3715 13.5353 15.5249 13.6547C15.6784 13.7711 15.8573 13.8294 16.0619 13.8294C16.2352 13.8294 16.3886 13.7896 16.5221 13.71C16.6556 13.6277 16.7636 13.5083 16.846 13.3521C16.9312 13.193 16.9823 12.9998 16.9994 12.7725H19.1812C19.1727 13.3493 19.0406 13.8521 18.7849 14.2811C18.5292 14.7072 18.167 15.0368 17.6982 15.2697C17.2323 15.5027 16.6755 15.6191 16.0278 15.6191ZM5.76323 14.0126C6.03311 14.5183 6.4209 14.9132 6.92658 15.1973C7.43226 15.4785 8.04022 15.6191 8.75044 15.6191C9.39817 15.6191 9.95499 15.5027 10.4209 15.2697C10.8896 15.0368 11.2519 14.7072 11.5075 14.2811C11.7632 13.8521 11.8953 13.3493 11.9039 12.7725H9.72203C9.70499 12.9998 9.65385 13.193 9.56863 13.3521C9.48624 13.5083 9.37828 13.6277 9.24476 13.71C9.11124 13.7896 8.95783 13.8294 8.78453 13.8294C8.57999 13.8294 8.40101 13.7711 8.2476 13.6547C8.09419 13.5353 7.97488 13.3578 7.88965 13.122C7.80442 12.8833 7.76181 12.5851 7.76181 12.2271C7.76181 11.8691 7.80442 11.5723 7.88965 11.3365C7.97488 11.0978 8.09419 10.9203 8.2476 10.8038C8.40101 10.6845 8.57999 10.6248 8.78453 10.6248C9.0459 10.6248 9.25897 10.7157 9.42374 10.8975C9.59135 11.0765 9.69078 11.3379 9.72203 11.6816H11.9039C11.901 11.1135 11.7703 10.6191 11.5118 10.1987C11.2533 9.77539 10.8882 9.44869 10.4166 9.21857C9.94789 8.98562 9.39249 8.86914 8.75044 8.86914C8.04022 8.86914 7.43226 9.01119 6.92658 9.29528C6.4209 9.57653 6.03311 9.97141 5.76323 10.4799C5.49334 10.9856 5.3584 11.5737 5.3584 12.2441C5.3584 12.9146 5.49334 13.5041 5.76323 14.0126Z"
        fill="currentColor"
    />
    <!-- <path id="text_left" d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm4.5 7.5h-1v1h1v-1zm0-1h-1v-1h1v1zm6 1h-1v1h1v-1zm0-1h-1v-1h1v1z" fill="currentColor"></path> -->
</svg>

<slot />

<!-- <CookieConsent /> -->
<!-- <FacebookPixel />
<TwitterPixel /> -->

<div
    id="modal-target"
    class="fixed top-0 left-0 w-screen h-screen bg-black/5 h-screen-safe empty:hidden z-50"
/>

<DiscountBanner2 code="BLACKFRIDAY">
    Black Friday is here! Enjoy 30% off all courses.
</DiscountBanner2>

<DiscountBanner2 code="gifted">
    Welcome Gifted visitor, enjoy your 10% discount on all courses!
</DiscountBanner2>

<DiscountBanner2 code="repod">
    Welcome, Rethinking Education listener. Enjoy your 20% discount on all
    courses!
</DiscountBanner2>

{#if under_maintenance}
    <section
        class="fixed bottom-safe-offset-4 right-0 z-10 px-4 xs:px-8 max-w-full"
    >
        <div
            class="bg-yellow-300 border-yellow-500/50 text-yellow-950 p-4 rounded-xl relative shadow-md"
        >
            <p>
                <b
                    >Our site is currently undergoing maintenance. Please check
                    back soon!</b
                >
            </p>
            <p />
        </div>
    </section>
{/if}

{#if enlarged_image_src}
    <ModalOverlay
        on:close={() => (enlarged_image_src = null)}
        shown={!!enlarged_image_src}
        class="flex items-center justify-center"
    >
        <img
            src={enlarged_image_src}
            alt=""
            class="max-w-full max-h-full object-contain mx-auto my-auto"
        />
    </ModalOverlay>
{/if}

<!-- 
<DiscountBanner code="backtoschool">
    Back to school sale! 15% off all courses and worksheets with the code <strong>backtoschool</strong>
</DiscountBanner> -->
